// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const DbsCustomerError = t.struct({
    errorMessage: t.String,
    errorStatus: t.Number
}, {
    defaultProps: {
        errorMessage: '',
        errorStatus: 0
    },
    name: 'DBSCustomerError'
});
